export default {
  "borderT": "XByp-",
  "borderB": "EE01j",
  "borderL": "_0ktYL",
  "borderR": "_4na7W"
};